<template>
  <div>
    <JumpType v-model="mValue" :options="mOptions" />
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import JumpType from "@/components/JumpType";

export default {
  name: "SchemaJumpData",
  mixins: [schemaMixin],

  components: {
    JumpType,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    console.log("0416 mValue", this.mValue);
    console.log("0416 options.types??bbbb", this.options.types);
    console.log("0416 mOptions??bbbb", this.mOptions);
  },
};
</script>
